<template>
  <nav-bar title="待检测任务" />
  <div class="search-container">
    <div class="search-box" @click="$router.push('/searchTaskCylinder')">
      <van-icon name="search" />
      <span>搜索气瓶</span>
    </div>
  </div>
  <Content :bottom="0" :top="120" @content-scroll="handleContentScroll">
    <Loading v-if="showLoading" :isLoading="isLoading" @reload="getList" />
    <ul class="list">
      <li
        class="list-item"
        v-for="item in list"
        :key="item.batchNo"
        @click="handleItemClick(item)"
      >
        <div class="desc">
          <span>批次号：{{ item.batchNo }}</span>
          <span>气瓶数量：{{ item.gsNum }}</span>
        </div>
        <div>检测类型：{{ item.ctypeName }}</div>
        <div>送检单位：{{ item.sendUnit }}</div>
        <div>送检日期：{{ item.sendDate }}</div>
      </li>
    </ul>
    <loading-more
      :finished="finished"
      :showLoadingMore="showLoadingMore"
      :loadingFail="loadingFail"
      :list="list"
      @reload="reload()"
    />
  </Content>
</template>

<script>
import { computed } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import { getUserCheckListForApp } from '@/api/cylinderManageUserHome'
import { useLoadingMore } from '@/hooks/useLoadingMore'
export default {
  name: 'Detection', // 待检测任务
  setup(props) {
    const store = useStore()
    const empId = computed(() => store.state.roleInfo.empId)
    const companyId = computed(() => store.state.roleInfo.companyId)
    const data = useLoadingMore(getUserCheckListForApp)
    const { getList, list, finished, loadingFail, pageParams } = data
    const router = useRouter()

    // 初始化list
    const init = () => {
      list.value = []
      pageParams.page = 1
      pageParams.userId = empId.value
      pageParams.companyId = companyId.value
      finished.value = false
      loadingFail.value = false
      getList()
    }
    init()
    const handleItemClick = (item) => {
      router.push({
        name: 'TaskCylinder',
        params: {
          data: JSON.stringify(item)
        }
      })
    }
    return {
      ...data,
      getList,
      handleItemClick
    }
  }
}
</script>

<style lang="scss" scoped>
.search-container {
  padding: 16px;
  font-size: 14px;
  color: #999;
  .search-box {
    border: 1px solid #ccc;
    border-radius: 5px;
    height: 38px;
    display: flex;
    align-items: center;
    padding: 0 12px;
    span {
      padding-left: 15px;
    }
  }
}
.list {
  padding: 0 16px;
  font-size: 14px;
  .list-item {
    background-color: #fff;
    padding: 10px 16px;
    margin-top: 16px;
    border-radius: 5px;
    line-height: 26px;
    .desc {
      color: #666;
      font-size: 12px;
      span {
        margin-right: 10px;
      }
    }
  }
}
.notice-content {
  font-size: 14px;
  line-height: 26px;
  color: #333;
  padding: 16px;
}
</style>
